export default __webpack_public_path__ + "static/media/200-300.7dd56c13.jpg";